module.exports = __webpack_public_path__ + "img/especialista77.fdd2f0fc.png";